import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

// font awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCoffee } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faTwitter,
  faYoutube,
  faInstagram
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCoffee);
library.add(faFacebook, faTwitter, faYoutube, faInstagram);

Vue.component("font-awesome-icon", FontAwesomeIcon);

//jquery
window.$ = window.jQuery = require("jquery");

// bootstrap
import BootstrapVue from "bootstrap-vue";

//element ui
import "./plugins/element.js";
//custom
import "./scss/app.scss";

//fontawesome
import "./plugins/fontawesome";
import "./plugins/fontawesome";

//leaflet
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";

//vue-meta
import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  keyName: "metaInfo",
  refreshOnceOnNavigation: true
});

// vue-cookie
Vue.use(require("vue-cookies"));

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

// Pusher setup
window.Pusher = require("pusher-js");

// Echo client setup
import Echo from "laravel-echo";

window.Echo = new Echo({
  authEndpoint: process.env.VUE_APP_API_BASE_URL + "/broadcasting/auth",
  broadcaster: "pusher",
  key: "4eb3247d476b1ef6e75d",
  cluster: "us2",
  encrypted: false
});

//bootstrap
Vue.use(BootstrapVue);
Vue.config.productionTip = false;

// authorization, token setup
import { client } from "./myaxios";

Vue.prototype.$axios = client;
Vue.prototype.$http = client;
// const token = localStorage.getItem("token");
const token = Vue.$cookies.get("token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    "Bearer " + token;
}
// let subdomainUrl = process.env.VUE_APP_API_BASE_URL_FIRST +
//     localStorage.getItem("city")?(localStorage.getItem("city")+"."):"" +
//     process.env.VUE_APP_API_BASE_URL_SECOND;
// Vue.prototype.$http.defaults.baseURL = subdomainUrl;
// Vue.prototype.$axios.defaults.baseURL = subdomainUrl;

//moment.js
const moment = require("moment");
import moment_timezone from "moment-timezone";

require("moment/locale/zh-cn");

Vue.use(require("vue-moment"), {
  moment,
  moment_timezone
});

//vue2-editor
import Vue2Editor from "vue2-editor";
import { Quill } from "vue2-editor";

import ImageResize from "quill-image-resize-vue";

Quill.register("modules/imageResize", ImageResize);
Vue.use(Vue2Editor);

// ----------------
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
